import type React from "react";

import { MultiLineContent } from "@/components/MultiLineContent/MultiLineContent";
import { PageGrid } from "@/components/PageGrid/PageGrid";
import { ProgressBar } from "@/components/ProgressBar/ProgressBar";
import { SectionCard } from "@/design-system/SectionCard";
import { useTranslation } from "@/translations";

interface BulkUploaadAddressesSubmittingViewProps {
  amountSubmitting: number;
  progress: number;
}

export function BulkUploaadAddressesSubmittingView({
  amountSubmitting,
  progress,
}: BulkUploaadAddressesSubmittingViewProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <PageGrid.Column size="100%">
      <SectionCard>
        <section className="mx-auto flex max-w-content-constrained flex-col items-center gap-space-md">
          <MultiLineContent align="center">
            {t("page.portfolio-address-bulk-upload.section.submitting", {
              count: amountSubmitting,
            })}
          </MultiLineContent>
          <ProgressBar progress={progress} />
        </section>
      </SectionCard>
    </PageGrid.Column>
  );
}
